"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinks = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLinks = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, space = _b.space, mediaQueries = _b.mediaQueries;
    return "\n    display: flex;\n    margin-right: -".concat(space[4], ";\n\n    > * {\n        margin-top: 0;\n        margin-bottom: 0;\n        margin-right: ").concat(space[4], ";\n    }\n\n    ").concat(mediaQueries.smallAndUp, " {\n        margin-right: -").concat(space[8], ";\n        > * {\n            margin-right: ").concat(space[8], ";\n        }\n    }\n");
});
